import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import SettingsGroup from 'components/Shared/SettingsGroup';
import { FlexRow } from 'components/Shared/Scaffolding';
import { Card } from 'components/Shared/Cards';
import { GLYPHS } from 'components/Shared/Icon';
import { TYPOGRAPHY } from 'theme';
import { controlsDescription, behaviorDescription, getLanguage } from 'modules/advancedSettings';
import { languageMismatch } from 'store';
import { useRecoilValue } from 'recoil';
import { languageNameByCodeSelector } from 'modules/languages';

const Language = styled.span`
    margin-right: 4px;
`;

const HighlightText = styled.span`
    display: inline-block;
    color: ${TYPOGRAPHY.COLOR_DANGER};
`;

const Label = styled.strong`
    flex: 0 0 auto;
`;

const Value = styled.span`
    flex: 1 1 auto;
    min-width: 50%;
    overflow-wrap: break-word;
    word-wrap: break-word;
    hyphens: auto;
`;

const Preview = ({
    onCardClick,
    language,
    controls,
    behavior,
    languageMismatch,
    className,
    labelClassName,
    contentClassName,
}) => {
    const languageName = useRecoilValue(languageNameByCodeSelector(language));
    return (
        <SettingsGroup
            name="Advanced Settings"
            description="Adjust specific advanced settings of your map"
            className={className}
            labelClassName={labelClassName}
            contentClassName={contentClassName}
        >
            <Card
                onClick={onCardClick}
                leftGlyph={GLYPHS.SETTINGS}
                leftGlyphColor={TYPOGRAPHY.COLOR_REDUCED}
                rightGlyph={GLYPHS.EDIT}
            >
                <FlexRow inline spacing="4px">
                    <Label>Language:</Label>
                    <Value>
                        <Language>{languageName}</Language>
                        {languageMismatch ? <HighlightText>**</HighlightText> : ''}
                    </Value>
                </FlexRow>
                <FlexRow inline spacing="4px">
                    <Label>Controls:</Label>
                    <span>{controls}</span>
                </FlexRow>
                <FlexRow inline spacing="4px">
                    <Label>Behavior:</Label>
                    <span>{behavior}</span>
                </FlexRow>
            </Card>
        </SettingsGroup>
    );
};

const mapStateToProps = (state) => ({
    language: getLanguage(state),
    controls: controlsDescription(state),
    behavior: behaviorDescription(state),
    languageMismatch: languageMismatch(state),
});

export default connect(mapStateToProps)(Preview);
